import React from 'react';
import { Tab, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

import LinksList from '../LinksList';

import { getHighlightingText } from '../../helpers';

const Home = ({ guides, filteredGuides, search, debounceSearch, onChangeSearch, onSelectKey, onExited, searchShadow, isLoading }) => (
  <Tab.Pane eventKey="Home" onExited={onExited}>
    <div className={`guides__search${searchShadow ? ' shadow' : ''}`}>
      <div className="guides__search-inline">
        <label htmlFor="guides-search" className="guides__search-icon" />
        <FormControl autoComplete="off" id="guides-search" type="text" placeholder="Search..." value={search} onChange={onChangeSearch} />
      </div>
    </div>

    {!debounceSearch.trim() && (
      <LinksList type="names" items={guides} fieldName="category_name" onClick={(tabData) => onSelectKey(tabData.category_name)} />
    )}

    {debounceSearch.trim() && (
      <ul className="guides__search-list">
        {isLoading && <div className="spinner" style={{ marginTop: '86px' }} />}
        {!isLoading
          && filteredGuides?.map((guide, index) => (
            <li className="guides__search-item" key={index}>
              <a
                href="# "
                className="guides__search-link"
                onClick={(e) => {
                  e.preventDefault();
                  onSelectKey(`${guide.category_name}.${guide.title}`);
                }}
              >
                <div className="title" dangerouslySetInnerHTML={getHighlightingText(guide.title, search)} />
                <div className="content" dangerouslySetInnerHTML={getHighlightingText(guide.content.slice(0, 100), search)} />
              </a>
            </li>
          ))}
        {!isLoading && !filteredGuides?.length ? (
          <li className="guides__search-item--empty">
            <span className="fas fa-search empty-icon" />
            <div>No search results…</div>
            <div className="text-helper">No articles found matching your query.</div>
          </li>
        ) : null}
      </ul>
    )}
  </Tab.Pane>
);

Home.propTypes = {
  guides: PropTypes.array,
  filteredGuides: PropTypes.array,
  search: PropTypes.string,
  debounceSearch: PropTypes.string,
  onChangeSearch: PropTypes.func,
  onSelectKey: PropTypes.func,
  onExited: PropTypes.func,
  searchShadow: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default Home;
